import { useNavigate } from "react-router-dom";
import ServiceHeader from "../components/Common/ImageHeader";
import ServicesGrid from "../components/OurService/Services";

const ServicesPage = () => {
  const navigate = useNavigate();
  const handleBreadcrumbClick = (href) => {
    if (href && href !== "#") {
      navigate(href);
    }
  };
  return (
    <>
      <ServiceHeader
        title="Our Services"
        subtitle={"Pleasure rationally encounter consequence that are painful. Nor again in there anyone who purchase"}
        backgroundImage="url('/png/our-service.png')"
        breadcrumbItems={[
          { label: "Home", href: "/" },
          { label: "Services", href: "#", isCurrentPage: true  },
        ]}
        onBreadcrumbClick={handleBreadcrumbClick}
      />
      <ServicesGrid />
    </>
  );
};

export default ServicesPage;
